import { z } from 'zod';

export const PRICEBOOK_DESCRIPTION_MAX_CHARACTERS = 2000;
export const PRICEBOOK_DESCRIPTION_MAX_MESSAGE = 'Description must be 2000 characters or fewer';

/**
 * Count the same thing the API's class-validator rule counts: Unicode code
 * points, after canonically-equivalent accents have been composed.
 *
 * JavaScript's `string.length` counts UTF-16 code units, so an emoji counts as
 * two and a pasted decomposed accent can count as two even though the operator
 * sees one character. That made visibly sub-2,000 descriptions fail in the
 * browser before the API ever saw them.
 */
export function normalizePricebookDescription(value: string): string {
  return value.normalize('NFC');
}

export function pricebookDescriptionCharacterCount(value: string | null | undefined): number {
  return Array.from(normalizePricebookDescription(value ?? '')).length;
}

export const pricebookDescriptionSchema = z
  .string()
  .transform(normalizePricebookDescription)
  .refine(
    (value) => pricebookDescriptionCharacterCount(value) <= PRICEBOOK_DESCRIPTION_MAX_CHARACTERS,
    PRICEBOOK_DESCRIPTION_MAX_MESSAGE,
  );
